import React from "react";
import { get } from "react-hook-form";
import MyLabel from "./MyLabel";

const PAN_REGEX = /[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}/;

const MyPAN = ({
  title = "PAN Number",
  name = "pan",
  register,
  setValue,
  errors,
  watch,
  placeholder = "ABCDE1234F",
  required = true,
  disabled = false,
  readonly = false,
}) => {
  const error = get(errors, name);

  const handleChange = (e) => {
    const value = e.target.value
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "");

    setValue(name, value, { shouldValidate: true });
  };

  return (
    <div className="form-group">
      <MyLabel name={name} title={title} required={required} />

      <div className="form-control-wrap">
        <input
          type="text"
          id={name}
          placeholder={placeholder}
          maxLength={10}
          {...register(name, {
            required: required
              ? { value: true, message: "PAN number is required" }
              : false,
            pattern: {
              value: PAN_REGEX,
              message: "Invalid PAN format (ABCDE1234F)",
            },
          })}
          className={`form-control ${error ? "is-invalid" : ""}`}
          onChange={handleChange}
          readOnly={readonly}
          disabled={disabled}
        />

        {error && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {error.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MyPAN;
